// extracted by mini-css-extract-plugin
export default {"info":"styles_info__+AAPs","row":"styles_row__1Wgt5"};